// src/components/filter.
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Link, useNavigate } from "react-router-dom";
import ReactDragListView from "react-drag-listview/lib/index.js";

import { Table, Col, Row, UncontrolledTooltip, Input } from "reactstrap";
import { IoIosAdd } from "react-icons/io";
import { GrDrag } from "react-icons/gr";

//import components
import Breadcrumbs from "components/_Common/Breadcrumb";
import DeleteModal from "components/_Common/DeleteModal";
import { useDispatch, useSelector } from "react-redux";

// actions
import { deleteBatch, listBatch } from "store/actions";
import AddEditModal from "../AddEdit/AddEditModal";
import toastr from "toastr";
import MyPagination from "components/_Common/MyPagination";
import {
  onSortBatch,
  fetchLanguageList,
  onBatchGroupReport,
  onScoreBatch,
} from "helpers/backend_api_helper";
import { withTranslation } from "react-i18next";
import { HiRefresh } from "react-icons/hi";
import { MdDownloadForOffline, MdRefresh } from "react-icons/md";
import axios from "axios";
import moment from "moment";
import Sortable from "react-sortablejs";

const List = (props) => {
  //meta title
  document.title = `${props.t("Batch")}  | ${props.t("Admin")}`;

  const { error, success, loading } = useSelector((state) => ({
    loading: state.Batches.loading,
    error: state.Batches.error,
    success: state.Batches.success,
  }));

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [languageList, setLanguageList] = useState();
  const [modal, setModal] = useState(false);
  const [itemData, SetItemData] = useState();
  const [tableData, SetTableData] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [filterData, setFilterData] = useState({
    limit: 25,
    page: currentPage,
    search: "",
  });

  const toggle = () => {
    if (modal) {
      setModal(false);
    } else {
      setModal(true);
    }
  };

  //delete question
  const [deleteModal, setDeleteModal] = useState(false);
  const onClickDelete = (item) => {
    SetItemData(item);
    setDeleteModal(true);
  };
  const handleDeleteBatch = () => {
    dispatch(
      deleteBatch({ ids: [itemData?.id] }, (res) => {
        if (res?.status === "success") {
          setDeleteModal(false);
          toastr.success(res?.message);
          fetchBatchList(filterData);
          setFilterData((prevFilterData) => ({
            ...prevFilterData,
            randomEvent: Math.random(),
          }));
        } else {
          toastr.error(res?.message);
        }
      })
    );
  };

  // edit
  const handleBatchClick = (data) => {
    setIsEdit(true);
    SetItemData(data);
    toggle();
  };

  // list
  const fetchBatchList = (filterData) => {
    dispatch(
      listBatch(filterData, (res) => {
        if (res?.status === "success") {
          SetTableData(res?.data);
          SetItemData({});
        }
      })
    );
  };
  useEffect(() => {
    fetchBatchList(filterData);
  }, [
    currentPage,
    filterData?.search,
    filterData?.limit,
    filterData?.question_type,
  ]);

  // filter
  const debounce = (func, delay) => {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => func.apply(this, args), delay);
    };
  };

  // Function to handle search
  const handleSearch = debounce((searchTerm) => {
    setFilterData((prevFilterData) => ({
      ...prevFilterData,
      search: searchTerm,
    }));
  }, 500);

  const handleLimit = (val) => {
    setFilterData((prevFilterData) => ({
      ...prevFilterData,
      limit: val,
    }));
  };

  const handleType = (val) => {
    setFilterData((prevFilterData) => ({
      ...prevFilterData,
      question_type: val,
    }));
  };

  // sorting row
  const handleChangeRow = async (oldIndex, newIndex, id) => {
    let data = { oldIndex, newIndex };
    try {
      const onRowSortRes = await onSortBatch(data, id);
      if (onRowSortRes.status === "success") {
        toastr.success(onRowSortRes?.message);
        // fetchBatchList(filterData)
      }
    } catch (error) {
      toastr.error(error?.response?.data?.message || "Server Error");
    }
  };

  const dragProps = {
    onDragEnd(fromIndex, toIndex) {
      const modifiedData = [...tableData?.batches];
      const item = modifiedData.splice(fromIndex, 1)[0];
      // const itemToIndex = modifiedData.splice(toIndex, 1)[0];
      modifiedData.splice(toIndex, 0, item);

      handleChangeRow(item?.sort, toIndex, item?.id);
      SetTableData({ batches: modifiedData, records: tableData?.records });
    },
    nodeSelector: "tr",
    handleSelector: "tr",
  };

  // delete selecetd
  const [deleteIds, setDeleteIds] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState([]);

  const toggleSelectAll = () => {
    setSelectAll(!selectAll);
    const ids = selectAll ? [] : tableData?.batches?.map((item) => item.id);

    setDeleteIds(ids || []);
  };

  const onChangeSelectDelete = (id) => {
    const updatedDeleteIds = deleteIds.includes(id)
      ? deleteIds.filter((deleteId) => deleteId !== id)
      : [...deleteIds, id];
    setDeleteIds(updatedDeleteIds);
  };

  const onDeleteSelected = () => {
    dispatch(
      deleteBatch({ ids: [...deleteIds] }, (res) => {
        if (res?.status === "success") {
          setDeleteModal(false);
          toastr.success(res?.message);
          fetchBatchList(filterData);
          setFilterData((prevFilterData) => ({
            ...prevFilterData,
            randomEvent: Math.random(),
          }));
          setDeleteIds([]);
          setSelectAll(false);
          setMultiDeleteModal(false);
        } else {
          toastr.error(res?.message);
          setMultiDeleteModal(false);
        }
      })
    );
  };

  const fetchLanguageLists = async () => {
    const listLang = await fetchLanguageList();
    setLanguageList(listLang?.data);
    setSelectedLanguage([listLang?.data[0]]);
  };

  useEffect(() => {
    fetchLanguageLists();
  }, []);

  //   language select function
  const onSelectLanguage = (langId, batchId) => {
    setSelectedLanguage([{ id: langId }]);
    // Check if there's already an entry with the same batchId
    // const existingEntry = selectedLanguage?.find(item => item.batchId === batchId);

    // if (existingEntry) {
    //     // If an entry with the same batchId exists, update its langId
    //     setSelectedLanguage(prevState => {
    //         return prevState?.map(item =>
    //             item.batchId === batchId ? { ...item, langId } : item
    //         );
    //     });
    // } else {
    //     // If no entry with the same batchId exists, add a new entry
    //     setSelectedLanguage(prevState => [...prevState, { langId, batchId }]);
    // }
  };

  // create ZIP
  const [zipLoading, setZipLoading] = useState(false);
  const [itemId, setItemId] = useState(null);

  const onCreateZip = async (batchId, type) => {
    setItemId(batchId);
    setZipLoading(true);
    const existingEntry = selectedLanguage.find(
      (item) => item.batchId === batchId
    );
    // if(existingEntry?.langId == ''){
    //     toastr.error("Please Select Language");
    //     setZipLoading(false);
    //     setSelectedLanguage([]);
    //     setItemId(null);
    //     return;
    // }
    // if(!existingEntry){
    //     toastr.error("Please Select Language");
    //     setZipLoading(false);
    //     return;
    // }else {
    try {
      let createGroupReport;
      if (type === "group") {
        createGroupReport = await onBatchGroupReport(
          batchId,
          existingEntry?.id || selectedLanguage[0].id
        );
      }

      if (type === "score") {
        createGroupReport = await onScoreBatch(
          batchId,
          existingEntry?.id || selectedLanguage[0].id
        );
      }
      if (createGroupReport?.status) {
        toastr.success(createGroupReport?.message);
        fetchBatchList(filterData);
        setZipLoading(false);
        fetchLanguageLists();
        setItemId(null);
      } else {
        toastr.error(createGroupReport?.message);
        setZipLoading(false);
        setItemId(null);
      }
    } catch (error) {
      toastr.error("Server Error");
      setZipLoading(false);
      setItemId(null);
    }
    // }
  };
  const downloadPdf = async (token) => {
    try {
      let baseUrl = process.env.REACT_APP_ENV == "development" ? process.env.REACT_APP_API_DEV_BASE_URL : process.env.REACT_APP_API_PROD_BASE_URL
      const response = await axios.get(
        `${baseUrl}/api/v1/utility/file-preview/${token}`
      );
      if (response?.status_code == "400") {
        return toastr.error(response?.message);
      } else {
        window.open(
          `${baseUrl}/api/v1/utility/file-preview/${token}`
        );
      }
    } catch (error) {
      return toastr.error(error?.response?.data?.message);
    }
  };

  const [multiDeleteModal, setMultiDeleteModal] = useState(false);
  const onClickMultiDelete = () => {
    setMultiDeleteModal(true);
  };
  const handleBatchId = (id) => {
    localStorage.setItem("batchId", id)
    navigate("/batches/track/list")
  }
  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteBatch}
        onCloseClick={() => setDeleteModal(false)}
        loading={loading}
        modalContent={props.t("Are you sure delete Schor ?")}
      />
      <DeleteModal
        show={multiDeleteModal}
        onDeleteClick={onDeleteSelected}
        onCloseClick={() => setMultiDeleteModal(false)}
        loading={loading}
        modalContent="Are you sure delete Question?"
      />
      <AddEditModal
        modal={modal}
        toggle={toggle}
        isEdit={isEdit}
        itemData={itemData}
        fetchBatchListData={() => fetchBatchList(filterData)}
      />
      <div className="page-content batches-list-main">
        <div className="container-fluid">
          <Breadcrumbs
            title={props.t("Batches")}
            breadcrumbItem={props.t("Manage Batches")}
          />

          <Row>
            <Col lg="12">
              <Row className="mb-2 d-flex show-select justify-spacebetween">
                <Col md={1} className="me-4 space-marg-rem">
                  <select
                    className="form-select custm-select"
                    onChange={(e) => handleLimit(e.target.value)}
                  >
                    <option value="25">{props.t("Show")} 25</option>
                    <option value="50">{props.t("Show")} 50</option>
                    <option value="75">{props.t("Show")} 75</option>
                    <option value="100">{props.t("Show")} 100</option>
                  </select>
                </Col>
                <Col md={2}>
                  <div className="search-box d-inline-block">
                    <div className="position-relative">
                      <label htmlFor="search-bar-0" className="search-label">
                        <input
                          onChange={(e) => {
                            handleSearch(e.target.value);
                          }}
                          id="search-bar-0"
                          type="text"
                          className="form-control"
                          placeholder={props.t("Search") + "..."}
                        />
                      </label>
                      <i className="bx bx-search-alt search-icon"></i>
                    </div>
                  </div>
                </Col>

                <Col md={4}></Col>
                <Col md={4} className="text-end pe-0">
                  <div className="custm-btns">
                    {deleteIds?.length > 0 && (
                      <button
                        disabled={deleteIds?.length <= 0 ? true : false}
                        className="btn btn-lg btn-soft-danger"
                        onClick={onClickMultiDelete}
                        style={{
                          background: deleteIds?.length <= 0 ? "#82345573" : "",
                          color: deleteIds?.length <= 0 ? "white" : "",
                        }}
                      >
                        {props.t("Delete Selected")}
                      </button>
                    )}

                    <button
                      onClick={() => {
                        setModal(true);
                        setIsEdit(false);
                        SetItemData({});
                      }}
                      className="btn btn-primary"
                    >
                      {props.t("Add Batch")}
                    </button>
                    <Link
                      id="refresh"
                      onClick={() => fetchBatchList(filterData)}
                      className="btn btn-light me-1"
                    >
                      <i className="mdi mdi-refresh"></i>
                    </Link>
                    <UncontrolledTooltip placement="top" target="refresh">
                      {props.t("Refresh")}
                    </UncontrolledTooltip>
                  </div>
                </Col>
              </Row>
              <div className="table-responsive">
                {
                  loading ? (
                    <div className="loader d-flex justify-content-center align-items-center mt-5">
                      <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>{" "}
                      {props.t("Loading")}
                    </div>
                  ) : (
                     <ReactDragListView {...dragProps}>
                    <Table className="table mb-0">
                      <thead>
                        <tr>
                          <th></th>
                          <th>
                            <label className="radio-check-label">
                              <input
                                className="fill-checkbox"
                                type="checkbox"
                                checked={selectAll}
                                onClick={toggleSelectAll}
                                onChange={toggleSelectAll}
                              />
                              <span className="radio-check"></span>
                            </label>
                          </th>
                          {/* <th>#</th> */}
                          <th className="main-data-fix-batches">
                            {" "}
                            {props.t("Batch Name")}
                          </th>
                          <th>{props.t("Deadline")}</th>

                          <th>{props.t("Participants")}</th>
                          <th>{props.t("Track")}</th>
                          <th>{props.t("Group Report")}</th>
                          <th>{props.t("Score Batch")}</th>

                          <th>{props.t("Status")}</th>
                          <th
                            style={{
                              textAlign: "center",
                              paddingRight: "25px",
                            }}
                          >
                            {props.t("Action")}
                          </th>
                        </tr>
                      </thead>
                      {tableData?.batches?.length <= 0 ? (
                        <tr>
                          <td
                            colSpan="10"
                            className="text-center no-record-found"
                          >
                            {props.t("No Record Found")}
                          </td>
                        </tr>
                      ) : (
                        <tbody>
                            {(tableData?.batches || [])?.map((item, index) => (
                              <tr key={index}>
                                {/* <td></td> */}
                                <td><GrDrag size={12} style={{ cursor: "pointer" }} /></td>
                                <td>
                                  <label className="radio-check-label">
                                    <input
                                      className="fill-checkbox"
                                      type="checkbox"
                                      onChange={toggleSelectAll}
                                      checked={deleteIds.includes(item.id)}
                                      onClick={() =>
                                        onChangeSelectDelete(item.id)
                                      }
                                    />
                                    <span className="radio-check"></span>
                                  </label>
                                </td>
                                {/* <td scope="row" className="drag-pointer">{item.id}</td> */}
                                <td>{item?.title}</td>
                                <td>
                                  {
                                    moment.utc(item?.deadline).format("DD-MM-YYYY")
                                  }

                                </td>
                                <td>
                                  <button
                                    onClick={() => {
                                      navigate(`/participants/list/${item?.id}`, {
                                        state: { batchData: item },
                                      });
                                    }}
                                  >
                                    <IoIosAdd size={20} />
                                    {props.t("Participants")}
                                  </button>
                                </td>
                                <td>
                                  <span
                                    className="btn btn-sm btn-soft-info"
                                    onClick={() => {
                                      navigate("/batches/track/list", {
                                        state: { batchData: item },
                                      });
                                    }}
                                  >
                                    <i
                                      className="bx bx-line-chart"
                                      id={`track-partic${item?.id}`}
                                    />
                                    <UncontrolledTooltip
                                      placement="top"
                                      target={`track-partic${item?.id}`}
                                    >
                                      {props.t("Track Participants")}
                                    </UncontrolledTooltip>
                                  </span>
                                </td>
                                <td className="group-report">
                                  <Input
                                    name="language"
                                    className="form-control size-batch-lang"
                                    type="select"
                                    onChange={(e) =>
                                      onSelectLanguage(e.target.value, item.id)
                                    }
                                  >
                                    {/* <option value="">{props.t("Select Language")}</option> */}
                                    {languageList?.map((data, key) => {
                                      return (
                                        <option key={key} value={data?.id}>
                                          {data?.label}
                                        </option>
                                      );
                                    })}
                                  </Input>
                                  {item.cronStatus != "P" && (
                                    <span
                                      id={
                                        item.cronFile
                                          ? `refreshGroup${item?.id}`
                                          : `createZip${item?.id}`
                                      }
                                      style={{ marginLeft: "10px" }}
                                      className={`btn track-data track-data-reload ${item.cronFile ? "reload-icon-track" : ""
                                        }`}
                                      onClick={() =>
                                        onCreateZip(item.id, "group")
                                      }
                                    >
                                      {item.cronFile ? (
                                        <MdRefresh />
                                      ) : (
                                        <i className="bx bxs-file-pdf" />
                                      )}
                                    </span>
                                  )}
                                  {item.cronStatus === "P" ? (
                                    <i
                                      id={
                                        item.cronStatus
                                          ? `generateGroup${item?.id}`
                                          : ""
                                      }
                                      style={{ marginLeft: "7px" }}
                                      className="bx bx-loader bx-spin font-size-16 align-middle me-2"
                                    ></i>
                                  ) : (
                                    item?.cronFile && (
                                      // <MdDownloadForOffline id="downloadGroup" onClick={() => downloadPdf(item?.cronFile)} size={25} style={{ color: "#62CEB0", cursor: "pointer" }} />
                                      <i
                                        id={`downloadGroup${item?.id}`}
                                        onClick={() =>
                                          downloadPdf(item?.cronFile)
                                        }
                                        size={25}
                                        className="batches-download bx bx-download"
                                        style={{ cursor: "pointer" }}
                                      ></i>
                                    )
                                  )}

                                  {item?.cronFile && (
                                    <UncontrolledTooltip
                                      placement="top"
                                      target={`downloadGroup${item?.id}`}
                                    >
                                      {props.t("Download")}
                                    </UncontrolledTooltip>
                                  )}
                                  {item.cronFile && (
                                    <UncontrolledTooltip
                                      placement="top"
                                      target={`refreshGroup${item?.id}`}
                                    >
                                      {props.t("Regenerate")}
                                    </UncontrolledTooltip>
                                  )}
                                  {item.cronStatus != "P" && !item.cronFile && (
                                    <UncontrolledTooltip
                                      placement="top"
                                      target={`createZip${item?.id}`}
                                    >
                                      {props.t("Create PDF")}
                                    </UncontrolledTooltip>
                                  )}

                                  {item.cronStatus === "P" ? (
                                    <UncontrolledTooltip
                                      placement="top"
                                      target={`generateGroup${item?.id}`}
                                    >
                                      {props.t("Generating...")}
                                    </UncontrolledTooltip>
                                  ) : (
                                    ""
                                  )}
                                </td>
                                <td>
                                  {item.cronZipStatus != "P" && (
                                    <button
                                      id={
                                        item.cronZipFile
                                          ? `regenerate${item?.id}`
                                          : `createFile${item?.id}`
                                      }
                                      className={`btn track-data track-data-reload ${item.cronZipFile
                                        ? "reload-icon-track"
                                        : "createFile"
                                        }`}
                                      onClick={() =>
                                        onCreateZip(item.id, "score")
                                      }
                                    >
                                      {item.cronZipFile ? (
                                        <MdRefresh />
                                      ) : (
                                        <i className="bx bx-archive"></i>
                                      )}
                                    </button>
                                  )}

                                  {item.cronZipStatus === "P" ? (
                                    <i
                                      id={`croneGenerate${item?.id}`}
                                      style={{ marginLeft: "7px" }}
                                      className="bx bx-loader bx-spin font-size-16 align-middle me-2"
                                    ></i>
                                  ) : (
                                    item?.cronZipFile && (
                                      // <MdDownloadForOffline id="download" onClick={() => downloadPdf(item?.cronZipFile)} size={25} style={{ color: "#62CEB0", cursor: "pointer" }} />
                                      <i
                                        id={`download${item?.id}`}
                                        onClick={() =>
                                          downloadPdf(item?.cronZipFile)
                                        }
                                        size={25}
                                        className="batches-download bx bx-download"
                                        style={{ cursor: "pointer" }}
                                      ></i>
                                    )
                                  )}
                                  {item.cronZipStatus === "P" ? (
                                    <UncontrolledTooltip
                                      placement="top"
                                      target={`croneGenerate${item?.id}`}
                                    >
                                      {props.t("Generating...")}
                                    </UncontrolledTooltip>
                                  ) : (
                                    ""
                                  )}
                                  {item?.cronZipFile && (
                                    <UncontrolledTooltip
                                      placement="top"
                                      target={`download${item?.id}`}
                                    >
                                      {props.t("Download")}
                                    </UncontrolledTooltip>
                                  )}
                                  {item.cronZipFile && (
                                    <UncontrolledTooltip
                                      placement="top"
                                      target={`regenerate${item?.id}`}
                                    >
                                      {props.t("Regenerate")}
                                    </UncontrolledTooltip>
                                  )}
                                  {item.cronZipStatus != "P" &&
                                    !item.cronZipFile && (
                                      <UncontrolledTooltip
                                        placement="top"
                                        target={`createFile${item?.id}`}
                                      >
                                        {props.t("Create Zip")}
                                      </UncontrolledTooltip>
                                    )}
                                </td>

                                <td>
                                  <button
                                    className={
                                      item?.is_active === "Y"
                                        ? "yes-btn"
                                        : "no-btn"
                                    }
                                  >
                                    {" "}
                                    {item?.is_active === "Y"
                                      ? "Active"
                                      : "In-Active"}
                                  </button>
                                </td>
                                <td>
                                  <ul className="list-unstyled hstack gap-1 mb-0">
                                    <li>
                                      <span
                                        className="btn btn-sm btn-soft-info"
                                        onClick={() => {
                                          handleBatchClick(item);
                                        }}
                                      >
                                        <i
                                          className="bx bx-edit"
                                          id={`edittooltip${item?.id}`}
                                        />
                                        <UncontrolledTooltip
                                          placement="top"
                                          target={`edittooltip${item?.id}`}
                                        >
                                          {props.t("Edit")}
                                        </UncontrolledTooltip>
                                      </span>
                                    </li>
                                    <li>
                                      <span
                                        className="btn btn-sm btn-soft-danger"
                                        onClick={() => {
                                          onClickDelete(item);
                                        }}
                                      >
                                        <i
                                          className="bx bx-trash"
                                          id={`deletetooltip${item?.id}`}
                                        />
                                        <UncontrolledTooltip
                                          placement="top"
                                          target={`deletetooltip${item?.id}`}
                                        >
                                          {props.t("Delete")}
                                        </UncontrolledTooltip>
                                      </span>
                                    </li>
                                  </ul>
                                </td>
                              </tr>
                            ))}
                         
                        </tbody>
                      )}
                    </Table>
                    </ReactDragListView>
                  )
                  
                }
              </div>
              {tableData?.records < filterData?.limit ? (
                ""
              ) : (
                <MyPagination
                  filterData={filterData}
                  recordsPerPage={filterData?.limit}
                  totalRecords={tableData?.records}
                  currentPage={currentPage}
                  onPageChange={(pageNumber) => {
                    setCurrentPage(pageNumber);
                    setFilterData((prevFilterData) => ({
                      ...prevFilterData,
                      page: pageNumber,
                    }));
                  }}
                />
              )}
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

List.propTypes = {
  history: PropTypes.object,
  t: PropTypes.any,
};

export default withTranslation()(List);
